"use strict";'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var react = require('react');
var t = require('styled-components');
var reactTooltip = require('@radix-ui/react-tooltip');
var jsxRuntime = require('react/jsx-runtime');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var t__default = /*#__PURE__*/_interopDefaultLegacy(t);

var k=`
  --background-tooltip: var(--color-neutral-900);
  --foreground-tooltip: var(--color-neutral-0);
  --foreground-tooltip-link: var(--color-blurple-400);
  --foreground-tooltip-link-active: var(--color-blurple-300);
  --foreground-link: var(--foreground-tooltip-link);

[data-theme='dark'] & {
  --background-tooltip: var(--color-neutral-500);
  --foreground-tooltip: var(--color-neutral-50);
  --foreground-tooltip-link: var(--color-blurple-300);
  --foreground-tooltip-link-active: var(--color-blurple-200);
  --foreground-link-active: var(--foreground-tooltip-link-active);
 }
 `,e=t__default["default"].div`
  display: inline-flex;
`,R={small:"width: 120px;",regular:"width: 200px;",large:"width: 320px;"},i=t__default["default"](reactTooltip.Content)`
  z-index: var(--z-index-300);
`,n=t__default["default"].div`
  ${k}

  background-color: var(--background-tooltip);
  border-color: var(--background-tooltip);
  border-radius: var(--border-radius-small);
  color: var(--foreground-tooltip);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-small);
  line-height: 1.5;
  padding: var(--spacing-small) var(--spacing-regular);
  text-align: center;
  white-space: normal;

  ${({$size:r})=>r?R[r]:"white-space: nowrap;"}
`,l=t__default["default"](reactTooltip.Arrow)`
  fill: var(--background-tooltip);
`;var p=react.forwardRef(({children:r,content:d,size:s,defaultOpen:g,disabled:u=!1,open:f,onOpenChange:c,delayDuration:m=300,placement:v,offset:T=5,container:x=document.body,...b},h)=>jsxRuntime.jsx(reactTooltip.Provider,{children:jsxRuntime.jsxs(reactTooltip.Root,{defaultOpen:g,open:u?!1:f,onOpenChange:c,delayDuration:m,...b,children:[jsxRuntime.jsx(reactTooltip.Trigger,{asChild:!0,children:jsxRuntime.jsx(e,{ref:h,children:r})}),jsxRuntime.jsx(reactTooltip.Portal,{container:x,children:jsxRuntime.jsxs(i,{sideOffset:T,side:v,children:[jsxRuntime.jsx(n,{$size:s,children:d}),jsxRuntime.jsx(l,{})]})})]})}));p.displayName="Tooltip";var D=t__default["default"](p)``;

exports.a = D;
